<nb-user
  *ngIf="!isLoading"
  [name]="user?.fullName"
  [nbContextMenu]="menuItems"
  nbContextMenuTag="userMenu"
  nbContextMenuTrigger="hover">
</nb-user>
